var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailedTaxInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 21,
    cy: 21,
    r: 21
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02_StockAwards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A_01",
    transform: "translate(-907.000000, -231.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(830.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(78.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#BABABA",
    strokeWidth: 1,
    cx: 21,
    cy: 21,
    r: 21.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Details/Grey",
    transform: "translate(11.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-14",
    fill: "#00B550",
    x: 0,
    y: 0,
    width: 4.75,
    height: 4.75,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-14",
    stroke: "#00B550",
    x: 0.5,
    y: 7.625,
    width: 3.75,
    height: 3.75,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-14",
    stroke: "#00B550",
    x: 0.5,
    y: 14.75,
    width: 3.75,
    height: 3.75,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-14",
    stroke: "#00B550",
    x: 7.625,
    y: 0.5,
    width: 3.75,
    height: 3.75,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-14",
    stroke: "#00B550",
    x: 7.625,
    y: 7.625,
    width: 3.75,
    height: 3.75,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-14",
    stroke: "#00B550",
    x: 7.625,
    y: 14.75,
    width: 3.75,
    height: 3.75,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-14",
    stroke: "#00B550",
    x: 14.75,
    y: 0.5,
    width: 3.75,
    height: 3.75,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-14",
    stroke: "#00B550",
    x: 14.75,
    y: 7.625,
    width: 3.75,
    height: 3.75,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-14",
    stroke: "#00B550",
    x: 14.75,
    y: 14.75,
    width: 3.75,
    height: 3.75,
    rx: 1
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedTaxInformation);
export default __webpack_public_path__ + "static/media/detailed-tax-information.4ec8915dcd4d24e70d07ff437d2f5b76.svg";
export { ForwardRef as ReactComponent };